<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Value</mat-label>
            <input matInput formControlName="value" placeholder="Enter text here..." autofocus />
            @if (form.get('value')?.hasError('required')) {
            <mat-error>Value is required</mat-error>
            }
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="submit()">
        Save
    </button>
</mat-dialog-actions>